import lockScroll from '../__utils/lockScroll';
class Hero {
    constructor() {
        this.hero = document.querySelector('.page-hero')
        this.video = this.hero && this.hero.querySelector('.hero-video__play')
        this.lightbox = document.querySelector('.hero-video-lightbox')
        this.lightboxClose = this.lightbox && this.lightbox.querySelector('.hero-video-lightbox__close')
    }
    init() {
        if (!this.video) return
        this.bindEvents()
    }
    bindEvents() {
        this.video.addEventListener('click', e => {
            e.preventDefault()
            this.lightbox.classList.add('active')
            lockScroll.lock()
        })
        this.lightboxClose.addEventListener('click', e => {
            e.preventDefault()
            this.lightbox.classList.remove('active')
            lockScroll.unlock()
        })
    }
}
export default new Hero()